import { Pipe, PipeTransform } from '@angular/core';
import { get2DecimalsFormatNumber } from '@symphony-solo/shared/utils/src';
import { Currency } from './currency.enum';

@Pipe({ name: 'priceExtract' })
export class PricePipe implements PipeTransform {
  private currency = Currency.Pound;

  public transform(value: string) {
    const symbol = value && Number(value) < 0 ? '-' : '';
    const absPriceValue = Math.abs(Number(value));
    return symbol + this.currency + (value ? get2DecimalsFormatNumber(absPriceValue) : '00.00');
  }
}
